module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"display_by_product":"按产品评价","search_placeholder":"评论关键词搜索"}}')
  delete Component.options._Ctor
}
